import { render } from "./InvitationComplete.vue?vue&type=template&id=ace418b0"
import script from "./InvitationComplete.vue?vue&type=script&lang=js"
export * from "./InvitationComplete.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__